import {$session} from "dot-framework"
import Swal from "sweetalert2"
import moment from "moment"
import UAParser from "ua-parser-js"

const Locales = require("@/asset/data/locales.json")
const brailleLanguageList = require("@/asset/data/brailleLanguageList.json")

export default {
    getExtension(fileName) {
        if (!fileName)
            return ''

        const fileSeparator = fileName.lastIndexOf(".")
        if (fileSeparator === -1)
            return ''
        

        return fileName.substring(fileSeparator + 1).toLowerCase()
    },
    gotoAccount() {
        const callback = `${window.location.protocol}//${window.location.host}/login-callback`
        const accountInfoUrl = $session.getAccountInfoUrl(callback)

        window.location.href = accountInfoUrl
    },
    async swalActive(options) {
        return await Swal.fire(options)
    },
    isExist(val) {
        return val !== undefined && val !== null
    },
    isString(val) {
        if (!val) return false

        return typeof val === 'string' && this.removeSpace(val) !== ''
    },
    isFunction(val) {
        return val !== undefined && val !== null && typeof val === 'function'
    },
    isEmptyObject(obj) {
        return obj === null || obj === undefined || typeof obj !== 'object' || Object.keys(obj).length === 0
    },
    removeSpace(val) {
        if (!val) return val

        return val.replaceAll(/\s/g, '')
    },
    textToBraille(target, targetText) {
        if (!targetText) {
            return ""
        }

        let hexData = targetText
        if (target === "content") {
            if (Array.isArray(hexData)) {
                hexData = targetText.join(' \n ')
            }
        } else {
            if (target === "") {
                hexData = hexData.replace(/\s/g, "")

                if (hexData.length % 40 !== 0) {
                    const ZERO_HEX_CHAR = "0"
                    const paddingCount = 40 - (hexData.length % 40)

                    hexData += ZERO_HEX_CHAR.repeat(paddingCount)
                }
            }
        }

        return hexData
    },
    getRandomNumber(size = 1) {
        const random = Math.random()
        const pow = Math.pow(10, size)

        return Math.floor(random * pow)
    },
    secondToTimeFormat(second, format = 'mm:ss') {
        if (!second) return format.replaceAll(/[a-zA-Z]/g, "0")
        
        return moment(second * 1000).format(format)
    },
    getInitLocale() {
        const lang = navigator.language.toLowerCase()
        
        //todo: 나중에 language code 그대로 써야 됨
        const code = lang.substring(0, 2)
        return this.getLocale(code)
    },
    getLocale(code) {
        return Locales.find(e => e.code === code)
    },
    getBrailleByLocale(localeCode) {
        const braille =  brailleLanguageList.find(e => e.code === localeCode && e.default)
        return braille ?? brailleLanguageList[0]
    },
    getBraille(data) {
        const braille = brailleLanguageList.find(e => {
            return e.grade === data.grade
                && e.kind === data.kind
                && e.language === data.language
                && e.pin === data.pin
                && e.code === data.code
        })
        
        return braille ?? brailleLanguageList[0]
    },
    isMacOs() {
        const parser = new UAParser()
        const os = parser.getOS()
        
        return os.name === "Mac OS"
    },
    downloadDtmFile(item) {
        if (!item) return

        const fileExtension = item.fileExtension
        const dtmNo = item.fileKey
        if (["dtm", "dtms"].includes(fileExtension)) {
            const hasAudio = item.dtmsJson && typeof item.dtmsJson === 'object' && item.dtmsJson.audioPath !== ""
            if (hasAudio) {
                window.open(`/drive-app/v1/dtma/images?DTM_NO=${dtmNo}`)
            }
            else {
                const fileName = item.dtmImg
                window.open(`/drive-app/file/${fileName}`)
            }
        }
        else {
            window.open(`/drive-app/v1/doc/download?dtmNo=${dtmNo}`)
        }
    },
    isCtrlKey (event) {
        return event.ctrlKey || (this.isMacOs() && event.metaKey)
    },
    isAltKey (event) {
        return event.altKey
    },
    removeTrailingNumberInParentheses(str) {
        return str.replace(/\s*\(\d+\)$/, '')
    },
    decodeHtmlEntities(text) {
        const textArea = document.createElement('textarea')
        textArea.innerHTML = text
        return textArea.value
    },
    encodeHtmlEntities(text) {
        const textArea = document.createElement('textarea')
        textArea.textContent = text
        return textArea.innerHTML
    }
}